import React from 'react';
import { Box } from '@chakra-ui/react';
import { useExchangeTabs } from 'hooks';
import { useTranslation } from 'localization';

import { Tabs } from 'components';

import { Head, SimpleExchange } from './components';

const Exchange: React.FC = () => {
  const { t } = useTranslation('component.exchange');

  const { active, setActive } = useExchangeTabs();

  return (
    <Box w="100%">
      <Head />
      <Box
        borderTopWidth="1px"
        borderTopColor="rgba(255,255,255,0.08)"
        pt={{ base: 4, lg: 6 }}
        pb={2}
      >
        <Tabs
          isLazy
          index={active}
          onChange={(activeIndex: number) => setActive(activeIndex)}
          tabData={[
            {
              label: t('tabs.simple'),
              content: <SimpleExchange />,
              isActive: true,
            },
            // Disable advance exchange for now
            // {
            //   label: t('tabs.advance'),
            //   content: <AdvanceExchange />,
            //   isActive: true,
            // },
          ]}
        />
      </Box>
    </Box>
  );
};

export default Exchange;
